import React, { Fragment, useCallback, useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { FINANCE_MODULE_SALES_INVOICE } from 'tennders-stracture/libs/permissions'
import useSession from 'tennders-auth/hooks/useSession'
import Attachment from 'tennders-market/common/components/element/Attachment'
import GHref from 'tennders-market/common/components/element/GHref'
import { withPermissionControl } from 'tennders-auth/hocs/withPermissionControl'
import useSalesInvoiceModal from 'tennders-finance/common/hooks/useSalesInvoiceModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'

const AddSalesInvoiceDocumentButton = ({ transaction: transactionProps }) => {
  const [transaction, setTransaction] = useState(transactionProps)
  const { isBroker } = useSession()
  const { t } = useTranslation()

  const [salesInvoices, setSalesInvoices] = useState([])

  const onClose = useCallback((fetch) => {
    fetch(transaction).then(data => data && setSalesInvoices(data))
  }, [transaction?.id])

  const {
    fetchSalesInvociesWithTransaction,
    loading,
    salesInvoiceModal,
    initializeSalesInvoice,
    initializeCreditNote,
    showSalesInvoice,
    showCreditNote
  } = useSalesInvoiceModal({ onClose, transaction })

  useEffect(() => {
    fetchSalesInvociesWithTransaction(transaction).then(data => {
      setSalesInvoices(data)
    })
  }, [transaction?.id])

  useEffect(() => {
    setTransaction(transactionProps)
  }, [transactionProps])

  const buildContent = useCallback(() => {
    const data = salesInvoices ? salesInvoices.map((sale) => {
      const creditNotes = [...sale.creditNotes]
      const showCreditNoteModal = (creditNote) => {
        showCreditNote(creditNote?.id, false)
      }
      return (
        <div className="pb-12 mb-12" key={`approved-${sale?.id}`}>
          <Attachment
            url={sale.documentUrl}
            onClick={() => showSalesInvoice(sale?.id, false)}
            title={t('salesInvoice:salesInvoice',
              {
                salesInvoiceId: sale?.uniqueFileName && sale?.generatedInvoiceNo
                  ? sale?.uniqueFileName : ''
              })}
            rightText={t(`creditNote:${sale?.status}`)}
            rightStyle={{
              alignSelf: 'flex-start',
              textAlign: 'right'
            }}
            bottomText={t('salesInvoice:salesInvoiceUploadedBy', {
              createdAt: sale.createdAtStr,
              createdBy: sale.createdByStr
            })}
          />
          {creditNotes && creditNotes.map((creditNote) => (
            <Fragment key={creditNote.documentUrl}>
              <Attachment
                url={creditNote.documentUrl}
                onClick={creditNote?.status === 'approved' ? null : () => {
                  showCreditNoteModal(creditNote)
                }}
                rightStyle={{
                  alignSelf: 'flex-start',
                  textAlign: 'right'
                }}
                title={t('creditNote:creditNote',
                  { creditNoteId: creditNote?.creditNoteId ?? '' })}
                rightText={t(`creditNote:${creditNote?.status}`)}
                bottomText={t('creditNote:creditNoteCreatedBy', {
                  createdAt: creditNote.createdAtStr,
                  createdBy: creditNote.createdByStr
                })}
              />
            </Fragment>
          ))}
          <div className="w-100 mt-6 d-flex">
            <GHref onClick={() => initializeCreditNote(transaction)} key={`add_Credit_note${sale.id}`}>
              <FontAwesomeIcon icon={faPlus} className="ml-8 mr-4" />
              {t('creditNote:addCreditNote')}
            </GHref>
          </div>
        </div>
      )
    }) : []

    data.push(
      <div className="d-flex row" key={transaction.id}>
        {loading && (
          <span className="mr-8">
            <FontAwesomeIcon icon={faSpinner} spin fontSize={14} />
          </span>
        )}
        <GHref
          onClick={async () => {
            await initializeSalesInvoice(transaction)
          }}
          key={new Date().toISOString()}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-4" />
          <span className="text-underline">{t('salesInvoice:generateSalesInvoice')}</span>
        </GHref>
      </div>
    )

    if (!data.length) {
      return null
    }
    return data
  }, [salesInvoices, loading])

  // non-broker users can't see this actions
  if (!isBroker() || !transaction.isBooked) {
    return null
  }

  const content = buildContent()

  if (!content) {
    return null
  }

  return (
    <div className="border-b pb-12 mb-12">
      {buildContent()}
      {salesInvoiceModal}
    </div>
  )
}

export default withPermissionControl(React.memo(AddSalesInvoiceDocumentButton), [
  FINANCE_MODULE_SALES_INVOICE
])
